// extracted by mini-css-extract-plugin
module.exports = {"forgotContainer":"resetPassword_forgotContainer__ZSzss","formStyles":"resetPassword_formStyles__23PxH","goBackBtn":"resetPassword_goBackBtn__28jOw"};